import { getThorViewEventProps, thorPushEvent } from '../common/thor';

export function domReady() {
    const userPassword = document.querySelector('#password');
    const userPasswordEye = document.querySelector('#user_password_eye');

    thorPushEvent('page_view', getThorViewEventProps('account', 'account_password_change'));

    userPasswordEye.addEventListener('click', () => {
        userPassword.setAttribute(
            'type',
            userPassword.getAttribute('type') === 'password' ? 'text' : 'password',
        );
    });
}
